module.exports = __webpack_public_path__ + "static/media/b838fa7b339168d246e6d8cfc93462fa.b7608a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/b838fa7b339168d246e6d8cfc93462fa.jpg
// module id = 266
// module chunks = 0